import React, { useEffect, useState } from "react";
import DisableSetupButton from "./buttons/DisableSetupButton";
import CancelButton from "./buttons/CancelButton";
import SaveChangesButton from "./buttons/SaveChangesButton";
import { useSelector } from "react-redux";
import { getOrganizationFeatureFlag } from "../../services-logic/base-logic";

const SetupActionButtons = ({ showActionButtons = false, isSaving, setIsSaving, onSave }) => {
  const { isNew } = useSelector((state) => state.info);
  const [allowedButtons, setAllowedButtons] = useState([]);

  // disable-enable,cancel,save;always-on=false

  useEffect(() => {
    const setupActions = getOrganizationFeatureFlag("SR-SNIPPET", "setupActions");

    if (showActionButtons) {
      setAllowedButtons(["disable-enable", "cancel", "save"]);
      return;
    }

    if (!setupActions) {
      setAllowedButtons([]);
      return;
    }

    const setupActionsArray = setupActions.split(",");
    const actions = [];
    setupActionsArray.forEach((action) => {
      actions.push(action.split(";")[0]);
    });
    setAllowedButtons(actions);
  }, []);

  return (
    <div className="flex gap-4 relative justify-end items-center">
      {/* {!isNew && allowedButtons.includes("disable-enable") && <DisableSetupButton />}
      {!isNew && allowedButtons.includes("disable-enable") && <div className="h-7 w-0.5 bg-gray-300" />} */}
      {!isNew && allowedButtons.includes("cancel") && <CancelButton isSaving={isSaving} />}
      {allowedButtons.includes("save") && <SaveChangesButton isSaving={isSaving} onSave={onSave} />}
    </div>
  );
};

export default SetupActionButtons;
